import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../constants/AuthContext";

const CustomerSidebar = ({ activeTab, setActiveTab }) => {
  const { authUser } = useContext(AuthContext);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="col-12 col-lg-4 col-xl-3">
        <div className="card d-none d-lg-block">
          <div className="card-body p-3 p-md-4">
            <div className="text-center border-bottom pb-3 mb-3">
              <div className="d-flex justify-content-center">
                <div className="user-image">
                  {authUser && (
                    <img src={authUser?.profile_pic} alt="profile" className="user-image" />
                  )}
                </div>
              </div>
              <div className="user-details mt-3">
                <h5 className="mb-0">{authUser?.user_name}</h5>
                <p className="text-muted m-0">{authUser?.email}</p>
              </div>
            </div>

            <div className="settings-menu">
              <ul className="nav flex-column">
                <li className="nav-item mb-3">
                  <button
                    onClick={() => handleTabClick("profile")}
                    className={`btn w-100 text-start ${activeTab === "profile" ? "text-primary-dark fw-bold" : "text-dark"}`}
                  >
                    <i className="far fa-user me-2"></i> Profile Setting
                  </button>
                </li>
                <li className="nav-item mb-3">
                  <button
                    onClick={() => handleTabClick("bookings")}
                    className={`btn w-100 text-start ${activeTab === "bookings" ? "text-primary-dark fw-bold" : "text-dark"}`}
                  >
                    <i className="far fa-calendar-check me-2"></i> My Bookings
                  </button>
                </li>
                <li className="nav-item">
                  <Link to="/logout" className="btn w-100 py-2 text-start text-dark" style={{ justifyContent: 'start' }}>
                    <i className="fa-regular fa-right-from-bracket me-2"></i> Logout
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="mobile-menu-footer d-lg-none p-0">
        <div className="container">
          <ul className="d-flex p-0 justify-content-between align-items-center gap-2 mb-0">
            <li className="d-flex align-items-center">
              <button onClick={() => handleTabClick("profile")}
                className={`btn text-center text-primary ${activeTab === "profile" ? "text-primary" : "text-dark" }`}>
                <i className="far fa-user"></i>
                <p>Profile</p>
              </button>
            </li>
            <li className="d-flex align-items-center">
              <button onClick={() => handleTabClick("bookings")}
                className={`btn text-center text-primary ${activeTab === "bookings" ? "text-primary" : "text-dark" }`}>
                <i className="far fa-calendar-check"></i>
                <p>Bookings</p>
              </button>
            </li>
            <li className="d-flex align-items-center">
              <Link to="/logout" className="btn text-center text-dark">
                <i className="fa-regular fa-right-from-bracket"></i>
                <p className="mb-4">Logout</p>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default CustomerSidebar;
